'use strict';

module.exports = function (input) {
  if (typeof input !== 'string') {
    throw new TypeError("Expected a string, got ".concat(typeof input));
  }

  return input.toLowerCase().replace(/\b[a-z](?=[a-z]{2})/g, function (letter) {
    return letter.toUpperCase();
  });
};